module.exports = __webpack_public_path__ + "img/img.8326d3f8.png";